import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useDisabled, useInstanceId } from '@wordpress/compose';

const CommentsForm = () => {
  const disabledFormRef = useDisabled();
  const instanceId = useInstanceId(CommentsForm);
  return createElement("div", {
    className: "comment-respond"
  }, createElement("h3", {
    className: "comment-reply-title"
  }, __('Leave a Reply')), createElement("form", {
    noValidate: true,
    className: "comment-form",
    ref: disabledFormRef
  }, createElement("p", null, createElement("label", {
    htmlFor: `comment-${instanceId}`
  }, __('Comment')), createElement("textarea", {
    id: `comment-${instanceId}`,
    name: "comment",
    cols: "45",
    rows: "8"
  })), createElement("p", {
    className: "form-submit wp-block-button"
  }, createElement("input", {
    name: "submit",
    type: "submit",
    className: "submit wp-block-button__link",
    label: __('Post Comment'),
    value: __('Post Comment')
  }))));
};

export default CommentsForm;
//# sourceMappingURL=form.js.map